import { render } from "./Index.vue?vue&type=template&id=455a9731&scoped=true"
import script from "./Index.vue?vue&type=script&lang=js"
export * from "./Index.vue?vue&type=script&lang=js"

import "./Index.vue?vue&type=style&index=0&id=455a9731&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-455a9731"

export default script